import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { cacheKeyLabel } from "@/lib/utils/cacheKeyLabel";
import { reportClientError } from "@/lib/utils/reportClientError";

export const studioQueryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      reportClientError(error, `query:${cacheKeyLabel(query.queryKey[0])}`);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      reportClientError(error, `mutation:${cacheKeyLabel(mutation.options.mutationKey?.[0])}`);
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: 1,
    },
  },
});

interface StudioQueryClientProviderProps {
  children: ReactNode;
}

const StudioQueryClientProvider = ({ children }: Readonly<StudioQueryClientProviderProps>) => {
  return <QueryClientProvider client={studioQueryClient}>{children}</QueryClientProvider>;
};

export default StudioQueryClientProvider;
